import { sbMsgBusInstance } from "./mbus";
import { GeneralTopics } from "./MessageBusTopics/General";
import { GeoTopics, GeoMessageSenderId } from "./MessageBusTopics/GeoComply";
import { BettingSlipTopics } from "./MessageBusTopics/BettingSlip";
export * from "./MessageBusTopics";
export var sbMsgBusPredefinedTopics = {
    BettingSlipTopics: BettingSlipTopics,
    GeneralTopics: GeneralTopics,
    GeoTopics: GeoTopics,
    GeoMessageSenderId: GeoMessageSenderId
};
window["sbMsgBus"] = sbMsgBusInstance;
// TODO: OFTL-115
window["sbMsgBus"]["sbMsgBusPredefinedTopics"] = sbMsgBusPredefinedTopics;
window["sbMsgBusPredefinedTopics"] = sbMsgBusPredefinedTopics;
export var sbMsgBus = sbMsgBusInstance;
//# sourceMappingURL=index.js.map